import React, { useState } from 'react';
import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';

import { createApiKey } from '../../../actions/user';
import ApiKey from './ApiKey';

export default function ApiKeysForm() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [submitting, setSubmitting] = useState(false);

  const createNewApiKey = async () => {
    setSubmitting(true);
    await dispatch(createApiKey());
    setSubmitting(false);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        <LoadingButton
          variant='contained'
          color='brand'
          startIcon={<AddIcon />}
          onClick={createNewApiKey}
          loading={submitting}
        >
          Create
        </LoadingButton>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        {user.api_keys && user.api_keys.length ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell align='center'>Created</TableCell>
                  <TableCell align='center'>Age</TableCell>
                  <TableCell align='center'>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {user.api_keys.map((key) => (
                  <ApiKey key={key.id} api_key={key} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert severity='info'>No keys configured.</Alert>
        )}
      </Grid>
    </Grid>
  );
}
